import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'servicedesk-widget-settings.content.error-sections.request-type-error.title',
		defaultMessage: 'Select a new default request type to enable the widget',
		description:
			'Title for the unusable request type error message, displayed when the user selects a request type which is not supported by the widget',
	},
	description: {
		id: 'servicedesk-widget-settings.content.error-sections.request-type-error.description',
		defaultMessage:
			'The widget is turned off because there’s a problem with the default request type. To fix the widget, choose a new default request type.',
		description:
			'Description for the unusable request type error message, displayed when the user selects a request type which is not supported by the widget',
	},
	descriptionRestricted: {
		id: 'servicedesk-widget-settings.content.error-sections.request-type-error.description-restricted',
		defaultMessage:
			'The widget isn’t currently enabled as restrictions were added to the default request type. To enable, select a new default request type or remove these restrictions.',
		description:
			'Description for the unusable request type error message, displayed when the user selects a request type which is restricted',
	},
});
